module.exports = __webpack_public_path__ + "media/images/easypin/marker-8dafca0838259b495fa46d0ba4a9c8a3.png";